import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const serviceList = dom.target.querySelectorAll('.feed-service');
    const searchInput = dom.target.querySelector('.js-search-input');

    if (serviceList.length && searchInput) {
        const filterServices = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            serviceList.forEach(service => {
                const title = service.querySelector('.content__title');
                const titleText = title ? title.innerText.toLowerCase() : '';

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);

                if (matchSearch) {
                    service.classList.remove('hidden');
                } else {
                    service.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterServices, 300);
        searchInput.addEventListener('input', handleInput);

        filterServices();
    }
});
